<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("plain-text-builder.title") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("plain-text-builder.note-title")
                    }}</label>
                    <div class="control">
                        <input type="text" class="input" v-model="title" />
                    </div>
                </div>
                <div class="field">
                    <label class="label">{{
                        $t("plain-text-builder.text")
                    }}</label>
                    <div class="control">
                        <textarea class="textarea" v-model="text" maxlength="800"></textarea>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button
                    class="button is-success"
                    :class="{ 'is-loading': saving }"
                    :disabled="emptyTitle"
                    @click="save"
                >
                    {{ $t("plain-text-builder.save") }}
                </button>
                <button class="button" @click="close">
                    {{ $t("plain-text-builder.cancel") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RepositoryFactory } from "@/services/api";
import { noteTypes } from "@/config/index.js";

export default {
    name: "plain-text-builder",
    props: {
        noteId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            text: "",
            title: "",

            saving: false,
        };
    },
    mounted() {
        if (this.noteId !== null) {
            let note = this.getNote(this.noteId);
            this.title = note.title;
            this.text = note.text;
        }
    },
    computed: {
        ...mapGetters("notes", ["getNote"]),
        ...mapGetters("conference", ["getConferenceId"]),
        emptyTitle() {
            return this.title === "";
        },
    },
    methods: {
        ...mapActions("notes", ["addNote", "setNote"]),
        close() {
            this.$emit("close");
        },
        async save() {
            this.saving = true;
            if (this.noteId !== null) {
                // Update
                try {
                    let note = this.getNote(this.noteId);
                    note.text = this.text;
                    note.title = this.title;
                    await RepositoryFactory.notes.updateNote({ note: note });

                    this.setNote(note);
                    this.close();
                } catch (error) {
                    window.console.log(error);
                }
            } else {
                // Save
                try {
                    let note = {
                        type: noteTypes.plainText,
                        roomId: this.getConferenceId,
                        title: this.title,
                        text: this.text,
                    };
                    let response = await RepositoryFactory.notes.addNote({
                        note: note,
                    });

                    note.id = response.data;
                    this.addNote(note);

                    this.close();
                } catch (error) {
                    window.console.log(error);
                }
            }
            this.saving = false;
        },
    },
};
</script>